import React from 'react';
import { Link } from 'react-router-dom';
import '../css/Footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-grid">
                <div className="footer-brand">
                    <span className="brand-name">Callide LLC</span>
                    <p>
                        Bridging business challenges and innovative technology solutions. Your trusted
                        partner in achieving operational excellence through technology.
                    </p>
                </div>
                <div className="footer-col">
                    <h4>Company</h4>
                    <ul>
                        <li><Link to="/">Home</Link></li>
                        <li><Link to="/about">About</Link></li>
                        <li><Link to="/contact">Contact</Link></li>
                    </ul>
                </div>
                <div className="footer-col">
                    <h4>Services</h4>
                    <ul>
                        <li><a href="/#services">Technology Consulting</a></li>
                        <li><a href="/#services">Custom Software</a></li>
                        <li><a href="/#services">Process Automation</a></li>
                    </ul>
                </div>
            </div>
            <div className="footer-bottom">
                <p>&copy; 2026 Callide LLC. All rights reserved.</p>
                <p>Proudly built in Wisconsin.</p>
            </div>
        </footer>
    );
};

export default Footer;
